'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const theme_Animation = require('../../../theme/Animation.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
const theme_Shadows = require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
require('react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("Surface", {
  root: (backgroundColor, shadow, borderColor) => [
    Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { borderRadius: "var(--zds-radius-medium)", transitionProperty: "box-shadow, border-color, background-color", transitionTimingFunction: theme_Animation.Animation.transitionTimingFunction, transitionDuration: theme_Animation.Animation.transitionDuration, alignItems: "stretch", flex: 1, maxWidth: "100%" }),
    backgroundColor && styleEncapsulation.withModifier(backgroundColor, {
      backgroundColor: theme_Colors.Colors[backgroundColor]
    }),
    borderColor && styleEncapsulation.withModifier(`border-${borderColor}`, {
      border: `1px solid ${theme_Colors.Colors[borderColor]}`
    }),
    shadow && styleEncapsulation.withModifier("hasShadow", {
      boxShadow: theme_Shadows.Shadows[shadow]
    })
  ]
});
const Surface = (props) => {
  const { backgroundColor = "transparent", shadow, borderColor } = props;
  return react.jsx("div", { css: Styles.root(backgroundColor, shadow, borderColor), "data-zds": true }, props.children);
};

exports.Surface = Surface;
//# sourceMappingURL=Surface.cjs.js.map
